import React from 'react';
import { colors } from 'theme/constants';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import { cxFunction } from 'util/className';

const HiringTeamSuccessBanner = ({
  cx,
  onClickClose,
  onClickDiscoverNow,
  onClickDontShowAgain,
}) => (
  <Box className={cx()} tcenter>
    <Box mt={80} p={40} bg={colors.lilac}>
      <Box pb={30}>
        <Text fs24 fw600 navy i18n="add_team.hiring_team_banner.title" />
        <br />
        <Text fs24 fw600 navy i18n="add_team.hiring_team_banner.subtitle" />
      </Box>
      <Box spaceevenly pb={30} ma>
        <Box grow>
          <Button
            fullWidth
            theme="primary-violet-generic"
            onClick={onClickClose}
            i18n="add_team.hiring_team_banner.later_button"
          />
        </Box>
        <Box grow ml={20}>
          <Button
            fullWidth
            theme="primary-purple"
            onClick={onClickDiscoverNow}
            i18n="add_team.hiring_team_banner.discover_button"
            linkTo="/hiring/dashboard"
          />
        </Box>
      </Box>
      <Box>
        <Button
          theme="link-purple"
          onClick={onClickDontShowAgain}
          i18n="add_team.hiring_team_banner.dont_show_again"
        />
      </Box>
    </Box>
  </Box>
);

export default cxFunction('HiringTeamSuccessBanner', HiringTeamSuccessBanner);
